import { useContext } from 'react'
import router from 'next/router'

import { AuthorizationContext } from 'src/shared/context'
import { TAgreementPreview } from 'src/shared/api/typing'

import { useQueryHook } from './queryHook'
import { API_ROUTES } from '../routes'
import { apiGet } from '../config'

interface IResponse {
  items: TAgreementPreview[]
  pagination: {
    totalCount: number
    perPage: number
    page: number
  }
}

interface IParams {
  page: number
  perPage: number
}

export const useGetListUnsignedAgreements = () => {
  const { token, setToken } = useContext(AuthorizationContext)
  const path = API_ROUTES.UNSIGNED_AGREEMENTS

  const queryObject = useQueryHook({
    key: [path, token, 'agreements'],
    fetcherFunction: async ({ page = 1, perPage = 20 }: IParams) => {
      try {
        const headers = { Authorization: `Bearer ${token}` }

        const { data } = await apiGet<object, IResponse>({
          path,
          params: {
            page,
            perPage,
          },
          headers,
        })

        return data
      } catch (error: any) {
        if (error.response?.status === 401) {
          setToken('')
          router.push('/')
        }
        throw error
      }
    },
  })

  if (queryObject.isLoading || queryObject.isError) {
    return {
      ...queryObject,
      data: null,
    }
  }

  return {
    ...queryObject,
    data: queryObject.data as IResponse | null,
  }
}
